// extracted by mini-css-extract-plugin
export default {"container":"app-loader_container__uJ-Fm","wrapper":"app-loader_wrapper__M-53L"};